module.exports = __webpack_public_path__ + "img/hr-green-hairy-grass-11.a62c3c20.png";